"use client"
import type { SwitchProps } from "@opensea/ui-kit"
import {
  classNames,
  FlexCenter,
  SkeletonBlock,
  SpaceBetween,
  Switch,
  TextBody,
} from "@opensea/ui-kit"
import { useLocalStorage } from "@opensea/ui-kit/hooks"
import { useTranslations } from "use-intl"
import { CREATOR_FEE_ENFORCED_LOCAL_STORAGE } from "../../flow/BottomSheetFlows/constants"

type Props = {
  className?: string
  creatorFeeEnforced: boolean
} & Pick<SwitchProps, "checked" | "disabled" | "onCheckedChange">

export const CreatorEarningsToggle = ({
  creatorFeeEnforced,
  checked,
  onCheckedChange,
  disabled,
}: Props) => {
  const t = useTranslations("wallet.CreatorEarningsToggle")
  const [_, setCreatorFeeEnforced] = useLocalStorage(
    CREATOR_FEE_ENFORCED_LOCAL_STORAGE,
    true,
  )
  const onChange = (checked: boolean) => {
    // Order matters, local storage must be set after
    onCheckedChange?.(checked)
    setCreatorFeeEnforced(checked)
  }
  const isChecked = creatorFeeEnforced ? true : checked

  return (
    <FlexCenter className="gap-2">
      <Switch
        checked={isChecked}
        disabled={creatorFeeEnforced || disabled}
        onCheckedChange={onChange}
      />
      <TextBody className="uppercase" color="text-secondary">
        {isChecked ? t("on") : t("off")}
      </TextBody>
    </FlexCenter>
  )
}

export const CreatorEarningsToggleSkeleton = ({
  className,
}: {
  className?: string
}) => {
  const t = useTranslations("wallet.CreatorEarningsToggle")

  return (
    <SpaceBetween className={classNames("py-3", className)}>
      <TextBody weight="semibold">{t("creatorEarnings")}</TextBody>

      <SkeletonBlock className="h-6 w-12 rounded-full" />
    </SpaceBetween>
  )
}
